var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdaptiveCruise24 = function SvgAdaptiveCruise24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.703 9h1.594a2.69 2.69 0 0 1 1.912.8c.506.512.791 1.206.791 1.93v7.977c0 .608-.24 1.191-.665 1.621A2.258 2.258 0 0 1 13.73 22h-2.46c-.602 0-1.18-.242-1.605-.672A2.305 2.305 0 0 1 9 19.707V11.73a2.754 2.754 0 0 1 .792-1.93 2.7 2.7 0 0 1 1.91-.8Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.603 13h1.787c.692 0 1.356.26 1.845.725a2.41 2.41 0 0 1 .765 1.75v2.85c0 .179-.075.35-.209.477a.732.732 0 0 1-.503.198H9.712a.732.732 0 0 1-.503-.198.658.658 0 0 1-.209-.477v-2.867a2.414 2.414 0 0 1 .769-1.737A2.684 2.684 0 0 1 11.603 13v0ZM9 15H7m11 0h-2M7 4l1.277-.832a6.912 6.912 0 0 1 1.975-.864A8.33 8.33 0 0 1 12.5 2c.8 0 1.676.103 2.415.304.739.2 1.41.494 1.975.864L18 4M9 6l.813-.416c.36-.185.786-.332 1.257-.432.47-.1.92-.152 1.43-.152.51 0 1.066.052 1.537.152.47.1.897.247 1.257.432L16 6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgAdaptiveCruise24;